import { CarsTableNext } from '@components/cars-table-next';
import { FilterProvider } from '@components/cars-table-next/filter/useFilter';
import { PageMeta } from '@components/page-meta';
import { RouteComponentProps, useNavigate } from '@reach/router';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import useQueryParam from 'src/hooks/useQueryParam';
import { searchAgentState } from 'src/stores/state';

const CarsPage = (_props: RouteComponentProps) => {
  const navigate = useNavigate();

  // logic to catch searchagent id before starting to render cars table
  // needed to prevent hook errors
  const { queryParam: searchAgentQueryParam } = useQueryParam('searchagent');
  const [, setSearchAgentId] = useRecoilState(searchAgentState);
  useEffect(() => {
    if (searchAgentQueryParam) {
      setSearchAgentId(searchAgentQueryParam);
      navigate('/cars');
    }
  }, [navigate, searchAgentQueryParam, setSearchAgentId]);

  return (
    <>
      <PageMeta title="common.car_plural" />
      <FilterProvider>
        <CarsTableNext />
      </FilterProvider>
    </>
  );
};

export default CarsPage;
